import React, { useEffect, useState } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import Sidebar from '../components/Sidebar';

const CalendarPage = () => {
    const { t, i18n } = useTranslation();
    const isRtl = i18n.language === 'ar';
    const [events, setEvents] = useState([]);
    const [cars, setCars] = useState([]);
    const [filters, setFilters] = useState({ voiture_id: '', status: '' });
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        fetchCars();
        fetchEvents();

        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        fetchEvents();
    }, [filters]);

    const fetchCars = async () => {
        try {
            const res = await axios.get('https://krili-loto.com/api/voitures');
            setCars(res.data);
        } catch (err) {
            console.error('Failed to fetch cars:', err);
        }
    };

    const fetchEvents = async () => {
        try {
            const res = await axios.get('https://krili-loto.com/api/reservations/calendar', {
                params: {
                    voiture_id: filters.voiture_id || undefined,
                    status: filters.status || undefined
                }
            });
            setEvents(res.data);
        } catch (err) {
            console.error('Failed to fetch reservations:', err);
        }
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    return (
        <Sidebar>
            <style>{`
                @media (max-width: 640px) {
                    .fc .fc-toolbar {
                        flex-direction: column !important;
                        gap: 10px;
                        align-items: center;
                    }
                    .fc .fc-toolbar-title {
                        font-size: 1.2rem !important;
                    }
                    .fc .fc-button {
                        padding: 4px 8px !important;
                        font-size: 0.8rem !important;
                    }
                }
            `}</style>
            <div className="min-h-screen bg-gray-50 p-6" dir={isRtl ? 'rtl' : 'ltr'}>
                <div className="max-w-7xl mx-auto">
                    <h1 className={`text-3xl font-bold text-gray-800 mb-6 ${isRtl ? 'text-right' : 'text-left'}`}>
                        {t('reservation_calendar')}
                    </h1>

                    {/* Filter Section */}
                    <div className="bg-white rounded-xl shadow-md p-6 mb-6">
                        <h2 className={`text-lg font-semibold text-gray-700 mb-4 ${isRtl ? 'text-right' : 'text-left'}`}>
                            {t('filters')}
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label htmlFor="voiture_id" className="block text-sm font-medium text-gray-600 mb-1">
                                    Voiture
                                </label>
                                <select
                                    id="voiture_id"
                                    name="voiture_id"
                                    onChange={handleFilterChange}
                                    className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                                >
                                    <option value="">Toutes les voitures</option>
                                    {cars.map((car) => (
                                        <option key={car.id} value={car.id}>
                                            {car.marque} {car.modele}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <label htmlFor="status" className="block text-sm font-medium text-gray-600 mb-1">
                                    Statut
                                </label>
                                <select
                                    id="status"
                                    name="status"
                                    onChange={handleFilterChange}
                                    className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                                >
                                    <option value="">Tous les statuts</option>
                                    <option value="en_attente">En attente</option>
                                    <option value="en_cours">En cours</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    {/* Calendar Section */}
                    <div className="bg-white rounded-xl shadow-md overflow-hidden p-2">
                        <FullCalendar
                            key={isMobile ? 'mobile' : 'desktop'}
                            plugins={[dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin]}
                            initialView={isMobile ? 'listMonth' : 'dayGridMonth'}
                            events={events}
                            height="auto"
                            headerToolbar={isMobile ? {
                                left: 'prev,next',
                                center: 'title',
                                right: 'listMonth'
                            } : {
                                left: 'prev,next today',
                                center: 'title',
                                right: 'dayGridMonth,dayGridWeek,timeGridDay,listMonth'
                            }}
                            eventDisplay="block"
                            eventColor="#4f46e5"
                            eventTextColor="#ffffff"
                            dayMaxEventRows={3}
                            aspectRatio={isMobile ? 1.0 : 1.8}
                            locale="fr"
                            buttonText={{
                                today: "Aujourd'hui",
                                month: 'Mois',
                                week: 'Semaine',
                                day: 'Jour',
                                list: 'Liste'
                            }}
                            editable={true}
                            selectable={true}
                            weekends={true}
                            firstDay={1} // Monday as first day
                        />
                    </div>
                </div>
            </div>
        </Sidebar>

    );
};

export default CalendarPage;